// import Glide from '@glidejs/glide';

export default () => {
    /*
    const slider = new Glide({
        container: '.carousel',
    }).mount();
    */
};

$(function() {

    $('.education-wrapper').on('click', 'h6', function() {
        $(this).closest('.education-wrapper').toggleClass('active');
    });

    $('a[href*=#]:not([href=#])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          
          if (target.length) {
            $('html,body').animate({
              scrollTop: target.offset().top
            }, 500);
            return false;
          }
        }
      });

});